export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'DruhPozadavku';
export const NAME = 'DruhPozadavku';
